// src/router/admin/system.ts
import type { RouteRecordRaw } from 'vue-router'
import { ROLE_GROUPS } from '../../constants/roleGroups'

export const adminSystemsRoutes: RouteRecordRaw[] = [
  {
    path: 'system/company-settings',
    name: 'admin.system.company-settings',
    component: () => import('../../views/admin/system/CompanySettingsView.vue'),
    meta: {
      title: 'Company Settings',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/admins',
    name: 'admin.system.admins',
    component: () => import('../../views/admin/system/SystemAdminsView.vue'),
    meta: {
      title: 'Administrators',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.users.view', 'admin.settings.users.manage'],
    },
  },
  { 
    path: 'system/roles', 
    name: 'admin.system.roles', 
    component: () => import('../../views/admin/system/SystemRolesPermissionsView.vue'), 
    meta: {
      title: 'Roles & Permissions',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.roles.view', 'admin.settings.roles.manage'],
    }
  },
  {
    path: 'system/apis', 
    name: 'admin.system.apis', 
    component: () => import('../../views/admin/system/SystemApisView.vue'), 
    meta: { title: 'APIs & Integrations', requiresAuth: true, requireRoles: ROLE_GROUPS.SUPER_ADMIN } 
  },
  {
    path: 'system/efris',
    name: 'admin.system.efris',
    component: () => import('../../views/admin/system/EfrisIntegrationView.vue'),
    meta: {
      title: 'EFRIS',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/efris/onboarding-queue',
    name: 'admin.system.efris-onboarding',
    component: () => import('../../views/admin/system/EfrisOnboardingQueueView.vue'),
    meta: {
      title: 'EFRIS Onboarding Queue',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/efris/reference-data',
    name: 'admin.system.efris-reference-data',
    component: () => import('../../views/admin/system/EfrisReferenceDataView.vue'),
    meta: {
      title: 'EFRIS Reference Data',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/billing-settings',
    name: 'admin.system.billing-settings',
    component: () => import('../../views/admin/billing/BillingSettingsView.vue'),
    meta: {
      title: 'Billing Settings',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.billing.view', 'admin.settings.billing.manage'],
    },
  },
  {
    path: 'system/payment-gateways',
    name: 'admin.system.payment-gateways',
    component: () => import('../../views/admin/system/PaymentGatewaysView.vue'),
    meta: {
      title: 'Payment Gateways',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.payment_gateways.view', 'admin.settings.payment_gateways.manage'],
    },
  },
  {
    path: 'system/tenant-access-policies',
    name: 'admin.system.tenant-access-policies',
    component: () => import('../../views/admin/system/TenantAccessPoliciesView.vue'),
    meta: {
      title: 'Tenant Access Policies',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.manage', 'admin.settings.view'],
    },
  },
  { 
    path: 'system/logs', 
    name: 'admin.system.logs', 
    component: () => import('../../views/admin/system/SystemLogsView.vue'), 
    meta: {
      title: 'Event Logs',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    }
  },
  { 
    path: 'system/backups', 
    name: 'admin.system.backups', 
    component: () => import('../../views/admin/system/SystemBackupsView.vue'), 
    meta: { title: 'Backups', requiresAuth: true, requireRoles: ROLE_GROUPS.SUPER_ADMIN } 
  },
  {
    path: 'system/changelogs',
    name: 'admin.system.changelogs',
    component: () => import('../../views/admin/system/PlatformChangelogsView.vue'),
    meta: {
      title: 'All Updates',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/changelogs/pending',
    name: 'admin.system.changelogs.pending',
    component: () => import('../../views/admin/system/PlatformChangelogsView.vue'),
    meta: {
      title: 'Pending Updates',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/changelogs/completed',
    name: 'admin.system.changelogs.completed',
    component: () => import('../../views/admin/system/PlatformChangelogsView.vue'),
    meta: {
      title: 'Completed Updates',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/changelogs/client-visible',
    name: 'admin.system.changelogs.client-visible',
    component: () => import('../../views/admin/system/PlatformChangelogsView.vue'),
    meta: {
      title: 'Client Visible Updates',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
  {
    path: 'system/changelogs/roadmap',
    name: 'admin.system.changelogs.roadmap',
    component: () => import('../../views/admin/system/PlatformChangelogsView.vue'),
    meta: {
      title: 'Roadmap Updates',
      requiresAuth: true,
      requireAnyPermissions: ['admin.settings.view', 'admin.settings.manage'],
    },
  },
]
